/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../components/Modal/Modal';
import {
   PrimaryButton,
   GhostButton,
   DangerButton,
} from '../../../styles/ui/Button';

// ---------------------------------------------------------------------------
// Confirmação simples do módulo Financeiro (ativar/desativar conta, reativar
// credencial). Usa o Modal compartilhado — nada de backdrop/foco forjado à mão
// (FC7 cap.2 H.2).
//
// `intent` decide a cor do botão de confirmação, seguindo G.1: 'write' (azul)
// para o que grava, 'danger' (vermelho) para o que derruba.
// ---------------------------------------------------------------------------

export default function ConfirmDialog({
   isOpen,
   onClose,
   onConfirm,
   title,
   children,
   confirmLabel = 'Confirmar',
   intent = 'write',
   isBusy = false,
}) {
   const ConfirmButton = intent === 'danger' ? DangerButton : PrimaryButton;

   const footer = (
      <>
         <GhostButton type="button" onClick={onClose} disabled={isBusy}>
            Cancelar
         </GhostButton>
         <ConfirmButton type="button" onClick={onConfirm} disabled={isBusy}>
            {isBusy ? 'Aguarde…' : confirmLabel}
         </ConfirmButton>
      </>
   );

   return (
      <Modal
         isOpen={isOpen}
         onClose={onClose}
         title={title}
         maxWidth="480px"
         footer={footer}
      >
         {children}
      </Modal>
   );
}

ConfirmDialog.propTypes = {
   isOpen: PropTypes.bool.isRequired,
   onClose: PropTypes.func.isRequired,
   onConfirm: PropTypes.func.isRequired,
   title: PropTypes.string.isRequired,
   children: PropTypes.node,
   confirmLabel: PropTypes.string,
   intent: PropTypes.oneOf(['write', 'danger']),
   isBusy: PropTypes.bool,
};
